import { Schemas } from 'src/openapi/generated/types';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

import { filterReservationFlowInvalidRequestDetails } from '../filter-reservation-flow-invalid-request-details';

export const getOrganizationAdminAccessErrorItems: (
  error: ReservationFlowInvalidRequestError,
) => Schemas.ReservationFlowInvalidRequestItem[] = (error) => {
  const { details } = error;

  return filterReservationFlowInvalidRequestDetails(details)
    .map((detail) => {
      return detail.invalid_items.filter((item) => {
        // OpenAPIが更新されていないため、anyを利用
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (item.type as any) === 'organization_admin_access_error';
      });
    })
    .flat() as Schemas.ReservationFlowInvalidRequestItem[];
};
